import { fromJS, Map, List } from 'immutable'
import { setIn } from 'utils/immutable'
import * as searchActions from 'actions/deprecated/search.js'
import * as dataTypes from 'utils/constants'
import { sortData } from 'utils/deprecated/search.js'
import { findMostRecentRevision } from 'utils/revisionHelpers'
import { extractFeatureId } from 'utils/uriHelpers'
import { createReducer } from '../utils'

export const initialSearchObjectState = (resourceType) => {
  const initialSearchState = {
    searchString: '',
    submittedSearchString: '',
    loadingInitialResults: false,
    loadingAdditionalResults: false,
    resultsRemaining: true,
    searchPerformed: false,
    sort: [],
    results: [],
    message: '',
    buttonMessage: 'Show comparison',
    buttonState: 'disabled',
    selectionLimit: 10,
    selectionKeys: [],
    selectedRecord: null,
    error: '',
    filters: null,
    startIndex: null,
  }

  if (resourceType) {
    return { ...initialSearchState, resourceType, submittedResourceType: '' }
  }

  return initialSearchState
}

export const initialState = fromJS({
  [dataTypes.FLEET]: initialSearchObjectState(),
  [dataTypes.TRUCK]: initialSearchObjectState(),
  [dataTypes.SUPPORT_PARAMETER]: initialSearchObjectState(dataTypes.O_MAP),
  [dataTypes.REFERENCE_PARAMETER]: initialSearchObjectState(),
  [dataTypes.FEATURE]: initialSearchObjectState(),
  [dataTypes.SWITCHES_AND_GAUGES]: initialSearchObjectState(),
  [dataTypes.CTP]: initialSearchObjectState(dataTypes.RESOURCE_CIRCUITS),
})

const getResourceAndState = (state, { data, resource }) => {
  const resourceState = state.get(resource)
  const pageResults = data ? data[resource] || [] : []

  return {
    resource,
    resourceState,
    pageResults,
  }
}

export const mapResult = (r) =>
  fromJS({ ...r, selected: false, disableSelector: false, expanded: false })

const handlers = {
  [searchActions.CREATE_SEARCH_STATE]: createSearchState,
  [searchActions.SET_RESOURCE_TYPE]: setResourceType,
  [searchActions.UPDATE_SEARCH_STRING]: updateSearchString,
  [searchActions.SET_SUBMITTED_RESOURCE_TYPE]: setSubmittedResourceType,
  [searchActions.SET_SUBMITTED_SEARCH_STRING]: setSubmittedSearchString,
  [searchActions.SET_SORT_STATE]: setSortState,
  [searchActions.SET_SELECTOR_STATE]: setSelectorState,
  [searchActions.SET_TABLE_MESSAGE]: setTableMessage,
  [searchActions.SET_TABLE_BUTTON]: setTableButton,
  [searchActions.POPULATE_SEARCH_RESULTS]: populateSearchResults,
  [searchActions.TOGGLE_SEARCH_RESULT_SELECTED]: toggleSearchResultSelected,
  [searchActions.TOGGLE_SEARCH_RESULT_SELECTED_WITH_SELECTION_KEYS]:
    toggleSearchResultSelectedWithSelectionKeys,
  [searchActions.CLEAR_SEARCH_RESULT_SELECTED]: clearSearchResultSelected,
  [searchActions.CLEAR_SELECTED_KEYS]: clearSelectedKeys,
  [searchActions.SET_UNSELECTED_ITEMS_SELECTABLE]: setUnselectedItemsSelectable,
  [searchActions.TOGGLE_SEARCH_RESULT_EXPANDED]: toggleSearchResultExpanded,
  [searchActions.CLEAR_SEARCH_RESULTS]: clearSearchResults,
  [searchActions.SET_FILTERS]: setFilters,
  [searchActions.SET_PROPERTIES]: setProperties,
  [searchActions.CLEAR_PROPERTIES]: clearProperties,
  [searchActions.REQUESTING_INITIAL_SEARCH_RESULTS]:
    requestingInitialSearchResults,
  [searchActions.INITIAL_SEARCH_RESULTS_RECEIVED]: initialSearchResultsReceived,
  [searchActions.INITIAL_SEARCH_RESULTS_NOT_RECEIVED]:
    initialSearchResultsNotReceived,
  [searchActions.TOGGLE_SELECTED_ROW]: toggleSelectedRow,
  [searchActions.TOGGLE_SEARCH_RESULT_COMPARE]: toggleSearchResultCompared,
  [searchActions.SET_UNSELECTED_ITEMS_SELECTABLE_SEARCHED_VEHICLES]:
    setUnselectedSearchedVehiclesSelectable,
  [searchActions.SET_CLEAR_SEARCHED_VEHICLES_COMPARE]:
    clearSearchedVehicleCompare,
  [searchActions.UPDATE_SEARCH_RESULT_ITEM]: updateSearchResultItem,
}

export default createReducer(initialState, handlers)

// export default function search(state = initialState, action) {
//   switch (action.type) {
function createSearchState(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  if (!resourceState) {
    if (resource === dataTypes.SUPPORT_PARAMETER) {
      return state.set(
        resource,
        fromJS(initialSearchObjectState(dataTypes.O_MAP))
      )
    }
    if (resource === dataTypes.CTP) {
      return state.set(
        resource,
        fromJS(initialSearchObjectState(dataTypes.RESOURCE_CIRCUITS))
      )
    }
    return state.set(resource, fromJS(initialSearchObjectState()))
  }
  return state
}
function setResourceType(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResourceState = resourceState.merge({
    resourceType: action.resourceType,
  })
  return state.set(resource, newResourceState)
}
function updateSearchString(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    searchString: action.searchString,
  })
  return state.set(resource, newResourceState)
}

function setSubmittedResourceType(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    submittedResourceType: action.resourceType,
  })
  return state.set(resource, newResourceState)
}

function setSubmittedSearchString(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    submittedSearchString: action.searchString,
  })
  return state.set(resource, newResourceState)
}

function setSortState(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  // Set new sort
  let newSort = resourceState.get('sort')

  if (action.keepPreviousSorts) {
    if (newSort.some((s) => s.get('id') === action.columnId)) {
      newSort = newSort.map((s) => {
        if (s.get('id') === action.columnId)
          return s.set('desc', !s.get('desc'))
        return s
      })
    } else {
      newSort = newSort.push(
        Map({
          id: action.columnId,
          desc: false,
        })
      )
    }
  } else {
    const currentSortItem = newSort.find((s) => s.get('id') === action.columnId)
    if (currentSortItem) {
      newSort = List([
        currentSortItem.set('desc', !currentSortItem.get('desc')),
      ])
    } else {
      newSort = fromJS([
        {
          id: action.columnId,
          desc: false,
        },
      ])
    }
  }

  // Sort data
  const data = resourceState.get('results')
  const sortedData = fromJS(sortData(data.toJS(), newSort.toJS()))

  // Set new state
  const newResourceState = resourceState.merge({
    sort: newSort,
    results: sortedData,
  })
  return state.set(resource, newResourceState)
}

function setSelectorState(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    results: resourceState
      .get('results')
      .map((result) => result.set('disableSelector', action.disabled)),
  })
  return state.set(resource, newResourceState)
}

function setTableMessage(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    message: action.message,
  })
  return state.set(resource, newResourceState)
}

function setTableButton(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const changeObject = {}
  if (action.state) changeObject.buttonState = action.state
  if (action.message) changeObject.buttonMessage = action.message

  const newResourceState = resourceState.merge(changeObject)
  return state.set(resource, newResourceState)
}

function populateSearchResults(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResourceState = resourceState.merge({
    results: fromJS(action.results),
    searchResultsPopulated: true,
  })
  return state.set(resource, newResourceState)
}

function toggleSearchResultSelected(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const { index } = action
  const newResourceState = resourceState.setIn(
    ['results', index, 'selected'],
    !resourceState.getIn(['results', index, 'selected'])
  )

  return state.set(resource, newResourceState)
}

function toggleSearchResultCompared(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const { serialNumber } = action
  const m2Vehicles = resourceState.get('m2Vehicles').toJS()
  const checPlusVehicles = resourceState.get('checPlusVehicles').toJS()

  let index
  let newResourceState = resourceState
  if (m2Vehicles.length > 0) {
    index = m2Vehicles.findIndex(
      (vehicle) => vehicle.serialNumber === serialNumber
    )
    if (index > -1) {
      newResourceState = resourceState.setIn(
        ['m2Vehicles', index, 'selected'],
        !resourceState.getIn(['m2Vehicles', index, 'selected'])
      )
    }
  }

  if (checPlusVehicles.length > 0) {
    index = checPlusVehicles.findIndex(
      (vehicle) => vehicle.serialNumber === serialNumber
    )
    if (index > -1) {
      newResourceState = resourceState.setIn(
        ['checPlusVehicles', index, 'selected'],
        !resourceState.getIn(['checPlusVehicles', index, 'selected'])
      )
    }
  }

  return state.set(resource, newResourceState)
}

function toggleSearchResultSelectedWithSelectionKeys(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const indexOfResource = resourceState
    .get('results')
    .findIndex((result) => result.get('uri') === action.record.uri)
  let newResourceState = resourceState
  let indexOfCurrSelection = -1

  if (action.singleSelect) {
    indexOfCurrSelection = resourceState
      .get('results')
      .findIndex((result) => result.get('selected') === true)
    // if the currently selected index is the same as the index of the row being toggled, then don't do anything here.

    if (indexOfCurrSelection > -1 && indexOfCurrSelection !== indexOfResource) {
      newResourceState = resourceState.setIn(
        ['results', indexOfCurrSelection, 'selected'],
        false
      )
      newResourceState = newResourceState.set('selectionKeys', fromJS([]))
    }
    const selectionKeys = resourceState.get('selectionKeys')
    if (selectionKeys.size > 0) {
      newResourceState = newResourceState.set('selectionKeys', fromJS([]))
    }
  }

  newResourceState = newResourceState.setIn(
    ['results', indexOfResource, 'selected'],
    !resourceState.getIn(['results', indexOfResource, 'selected'])
  )

  if (
    newResourceState.getIn(['results', indexOfResource, 'selected']) === true
  ) {
    newResourceState = newResourceState.update(
      'selectionKeys',
      (selectionKeys) => selectionKeys.push(action.record)
    )
  } else {
    newResourceState = newResourceState.set(
      'selectionKeys',
      newResourceState
        .get('selectionKeys')
        .filter((res) => res.uri !== action.record.uri)
    )
  }

  return state.set(resource, newResourceState)
}

function clearSearchResultSelected(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.set('selectedRecord', null)

  return state.set(resource, newResourceState)
}

function clearSelectedKeys(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.set('selectionKeys', List([]))
  return state.set(resource, newResourceState)
}

function setUnselectedItemsSelectable(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResults = resourceState
    .get('results')
    .map((result) =>
      result.get('selected') === false
        ? result.set('disableSelector', action.disabled)
        : result
    )
  const newResourceState = resourceState.merge({
    results: newResults,
  })
  return state.set(resource, newResourceState)
}

function setUnselectedSearchedVehiclesSelectable(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const m2Vehicles = resourceState
    .get('m2Vehicles')
    .map((result) =>
      result.get('selected') === false
        ? result.set('disableSelector', action.disabled)
        : result
    )
  const checPlusVehicles = resourceState
    .get('checPlusVehicles')
    .map((result) =>
      result.get('selected') === false
        ? result.set('disableSelector', action.disabled)
        : result
    )
  const newResourceState = resourceState.merge({
    m2Vehicles,
    checPlusVehicles,
  })
  return state.set(resource, newResourceState)
}

function clearSearchedVehicleCompare(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const m2Vehicles = resourceState
    .get('m2Vehicles')
    .map((result) => result.set('selected', false))
  const checPlusVehicles = resourceState
    .get('checPlusVehicles')
    .map((result) => result.set('selected', false))
  const newResourceState = resourceState.merge({
    m2Vehicles,
    checPlusVehicles,
  })
  return state.set(resource, newResourceState)
}

function toggleSearchResultExpanded(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const { index } = action
  const newResourceState = resourceState.setIn(
    ['results', index, 'expanded'],
    !resourceState.getIn(['results', index, 'expanded'])
  )

  return state.set(resource, newResourceState)
}

function clearSearchResults(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const blankResourceState = {
    results: [],
    selectionKeys: [],
    searchString: action.textPersist ? resourceState.get('searchString') : '',
    searchPerformed: false,
    loadingInitialResults: false,
    selectedRecord: null,
    resourceType: null,
    filters: null,
    submittedSearchString: '',
    totalResults: 0,
    searchResultsPopulated: false,
    m2Vehicles: [],
    notFoundVehicles: [],
    checPlusVehicles: [],
    unsupportedVehicles: [],
  }
  if (resource === dataTypes.CTP)
    blankResourceState.resourceType = dataTypes.RESOURCE_CIRCUITS
  if (resource === dataTypes.SUPPORT_PARAMETER)
    blankResourceState.resourceType = dataTypes.O_MAP
  const newResourceState = resourceState.merge(blankResourceState)
  return state.set(resource, newResourceState)
}
function setFilters(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResourceState = resourceState.merge({ filters: action.filters })

  return state.set(resource, newResourceState)
}

function setProperties(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResourceState = resourceState.merge({
    properties: action.properties,
  })

  return state.set(resource, newResourceState)
}

function clearProperties(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)
  const newResourceState = resourceState.merge({ properties: null })

  return state.set(resource, newResourceState)
}

function requestingInitialSearchResults(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    loadingInitialResults: true,
    searchPerformed: true,
  })
  return state.set(resource, newResourceState)
}

function initialSearchResultsReceived(state, action) {
  const { resource, resourceState, pageResults } = getResourceAndState(
    state,
    action
  )

  // There are results remaining if it is not a truck search, some data is returned, and the done flag is false or unset.
  // Truck searches will always return all results at once, there will never be additional results.
  const resultsRemaining =
    ![dataTypes.CTP, dataTypes.TRUCK].includes(resource) &&
    pageResults.length > 0 &&
    !action.data.done

  let results
  let unsupportedVehicles = []
  let notFoundVehicles = []
  let m2Vehicles = []
  let checPlusVehicles = []
  if (resource === dataTypes.FLEET) {
    results = action.data.vehicles.map(mapResult)
  } else if (resource === dataTypes.CTP) {
    if (action.data[dataTypes.RESOURCE_CIRCUITS]) {
      results = action.data[dataTypes.RESOURCE_CIRCUITS].map(mapResult)
    }
    if (action.data[dataTypes.RESOURCE_BUNDLES]) {
      results = action.data[dataTypes.RESOURCE_BUNDLES].map(mapResult)
    }
  } else if (resource === dataTypes.TRUCK) {
    m2Vehicles = pageResults.filter(
      (x) => x.vehicleType === dataTypes.VEHICLE_TYPE_M2
    )
    checPlusVehicles = pageResults.filter(
      (x) => x.vehicleType === dataTypes.VEHICLE_TYPE_CHEC_PLUS
    )
    unsupportedVehicles = pageResults.filter(
      (x) => x.vehicleType === dataTypes.UNSUPPORTED
    )
    notFoundVehicles = pageResults.filter(
      (x) => x.vehicleType === dataTypes.NOTFOUND
    )
  } else {
    // For FEATURE searches, default each feature to its most recent revision
    // This matches the behavior of the non-deprecated search reducer
    const processedResults =
      resource === dataTypes.FEATURE
        ? pageResults.map((feature) => {
            if (feature.revisions && feature.revisions.length > 0) {
              const mostRecentRev = findMostRecentRevision(feature.revisions)
              if (mostRecentRev) {
                return {
                  ...feature,
                  id:
                    mostRecentRev.id ||
                    extractFeatureId(mostRecentRev.uri) ||
                    feature.id,
                  uri: mostRecentRev.uri || feature.uri,
                  revision:
                    mostRecentRev.revision ||
                    mostRecentRev.release ||
                    feature.revision,
                  status: mostRecentRev.status || feature.status,
                  partNumber: mostRecentRev.partNumber || feature.partNumber,
                }
              }
            }
            return feature
          })
        : pageResults
    results = processedResults.map(mapResult)
  }
  let newResourceState = resourceState.merge({
    resultsRemaining: resource !== dataTypes.FLEET ? resultsRemaining : false,
    results,
    unsupportedVehicles,
    notFoundVehicles,
    m2Vehicles,
    checPlusVehicles,
    totalResults: action.totalResults,
    loadingInitialResults: false,
    startIndex: action.startIndex,
  })

  const selectionKeys = newResourceState.get('selectionKeys').toJS()

  if (selectionKeys.length > 0) {
    const selectedUris = selectionKeys.map((selection) => selection.uri)
    const selectedRows = newResourceState
      .get('results')
      .toJS()
      .map((row) => {
        if (selectedUris.indexOf(row.uri) !== -1) {
          return {
            ...row,
            selected: true,
          }
        }

        return row
      })
    newResourceState = newResourceState.set('results', fromJS(selectedRows))
  }

  return state.set(resource, newResourceState)
}

function initialSearchResultsNotReceived(state, action) {
  const { resource, resourceState } = getResourceAndState(state, action)

  const newResourceState = resourceState.merge({
    results: [],
    loadingInitialResults: false,
    searchPerformed: false,
    error: action.error,
  })
  return state.set(resource, newResourceState)
}

function updateSearchResultItem(state, action) {
  const { resource, itemId, updatedData } = action
  const resourceState = state.get(resource)
  const results = resourceState.get('results')

  // Find item index by matching id
  const itemIndex = results.findIndex((item) => item.get('id') === itemId)

  if (itemIndex === -1) {
    return state // Item not found, no update
  }

  // Merge updated data into the item
  const updatedResults = results.update(itemIndex, (item) =>
    item.merge(fromJS(updatedData))
  )

  const newResourceState = resourceState.set('results', updatedResults)
  return state.set(resource, newResourceState)
}

function toggleSelectedRow(state, action) {
  const { record, resource } = action

  return setIn([resource, 'selectedRecord'], record)(state)
}
